import React, { useEffect, useRef, useState } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
  root: {
    position: "fixed",
    top: "0",
    width: "100%",
    zIndex: "1",
    opacity: "0",
    transition: "all .3s smooth",
    [theme.breakpoints.down("sm")]: {
      display: "none !important",
    },
  },
  link: {
    display: "flex",
    alignItems: "center",
    textDecoration: "none",
    color: "#fbc707",
  },
  name: {
    fontSize: "2em",
    fontWeight: "600",
    padding: "0 1em 0em 0.3em",
  },
  menu: {
    display: "flex",
    marginLeft: "auto",
    marginRight: "5%",
  },
  menuItem: {
    color: "#fbc707",
    padding: "0 .5rem",
    fontSize: "1em",
  },
}));

const NavBar = ({ refProps, refInView, scrollTo }) => {
  const classes = useStyles();
  const [scrollY, setScrollY] = useState(0);

  const navbar = useRef(null);
  const homeTextRef = useRef(null);
  const aboutTextRef = useRef(null);
  const servicesTextRef = useRef(null);
  const consultationServicesTextRef = useRef(null);
  const contactTextRef = useRef(null);

  const theme = useTheme();
  const isSmallDevice = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    window.addEventListener("scroll", () => setScrollY(window.scrollY));

    return () =>
      window.removeEventListener("scroll", () => setScrollY(window.scrollY));
  }, []);

  useEffect(() => {
    if (isSmallDevice) navbar.current.style.width = "none";
    else navbar.current.style.display = "block";
  }, [isSmallDevice]);

  useEffect(() => {
    if (scrollY > 20) navbar.current.style.opacity = "1";
    else navbar.current.style.opacity = "0";
  }, [scrollY]);

  useEffect(() => {
    const refTextProps = {
      home: homeTextRef,
      about: aboutTextRef,
      services: servicesTextRef,

      consultationServices: consultationServicesTextRef,
      contact: contactTextRef,
    };
    setActive(refTextProps[refInView]);
  }, [refInView]);

  const setActive = (ref) => {
    homeTextRef.current.style.borderBottom = "0";
    homeTextRef.current.style.fontWeight = "normal";
    aboutTextRef.current.style.borderBottom = "0";
    aboutTextRef.current.style.fontWeight = "normal";
    servicesTextRef.current.style.borderBottom = "0";
    servicesTextRef.current.style.fontWeight = "normal";
    consultationServicesTextRef.current.style.borderBottom = "0";
    consultationServicesTextRef.current.style.fontWeight = "normal";
    contactTextRef.current.style.borderBottom = "0";
    contactTextRef.current.style.fontWeight = "normal";
    if (ref) {
      ref.current.style.borderBottom = "2px solid";
      ref.current.style.fontWeight = "500";
    }
  };

  return (
    <div className={classes.root} ref={navbar}>
      <AppBar position="static">
        <Toolbar>
          <a href="/" className={classes.link}>
            <img
              src="assets/img/logo.png"
              style={{ height: "2.5em" }}
              alt="LIC Logo"
            />
            <Typography className={classes.name}>{"Singarajan G"}</Typography>
          </a>
          <div className={classes.menu}>
            <div
              onClick={() => {
                window.scrollTo({ top: 0, behavior: "smooth" });
                setActive(homeTextRef);
              }}
              style={{ cursor: `${scrollY > 20 ? "pointer" : "default"}` }}
            >
              <Typography className={classes.menuItem} ref={homeTextRef}>
                {"Home"}
              </Typography>
            </div>
            <div
              onClick={() => {
                scrollTo(refProps.about);
                setActive(aboutTextRef);
              }}
              style={{ cursor: `${scrollY > 20 ? "pointer" : "default"}` }}
            >
              <Typography className={classes.menuItem} ref={aboutTextRef}>
                {"About"}
              </Typography>
            </div>
            <div
              onClick={() => {
                scrollTo(refProps.services);
                setActive(servicesTextRef);
              }}
              style={{ cursor: `${scrollY > 20 ? "pointer" : "default"}` }}
            >
              <Typography className={classes.menuItem} ref={servicesTextRef}>
                {"Services"}
              </Typography>
            </div>
            <div
              onClick={() => {
                scrollTo(refProps.consultationServices);
                setActive(consultationServicesTextRef);
              }}
              style={{ cursor: `${scrollY > 20 ? "pointer" : "default"}` }}
            >
              <Typography
                className={classes.menuItem}
                ref={consultationServicesTextRef}
              >
                {"Consultation Services"}
              </Typography>
            </div>
            <div
              onClick={() => {
                scrollTo(refProps.contact);
                setActive(contactTextRef);
              }}
              style={{ cursor: `${scrollY > 20 ? "pointer" : "default"}` }}
            >
              <Typography className={classes.menuItem} ref={contactTextRef}>
                {"Contact"}
              </Typography>
            </div>
          </div>
        </Toolbar>
      </AppBar>
    </div>
  );
};

export default NavBar;
